import { useContext, useEffect, useState } from "react";
import "./PermanentDeleteModal.css";
import { Context } from "../../../../context/Context";
import { Button, Input } from "../../../ui";

export default function PermanentDeleteModal({
  open,
  count = 0,
  deleting = false,
  error = "",
  onConfirm,
  onCancel,
}) {
  const { lang = "ar" } = useContext(Context);
  const [confirmationText, setConfirmationText] = useState("");
  const ar = lang === "ar";
  const requiredConfirmation = ar ? "حذف نهائي" : "Permanent Delete";
  const isConfirmationValid =
    confirmationText === requiredConfirmation;

  useEffect(() => {
    if (!open) {
      setConfirmationText("");
    }
  }, [open]);

  if (!open) return null;

  return (
    <div className="lud-permanent-delete-modal__overlay">
      <div
        className="lud-permanent-delete-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="lud-permanent-delete-title"
      >
        <h4 id="lud-permanent-delete-title">{ar ? "حذف نهائي" : "Permanent delete"}</h4>

        <p className="lud-permanent-delete-modal__warning">
          {ar
            ? `سيتم حذف ${count} من الملفات المحددة وجميع النسخ السابقة نهائيًا من قاعدة البيانات وCloudinary، ولن يمكن استرجاعها بعد تنفيذ العملية.`
            : `${count} selected file(s) and all previous versions will be permanently deleted from the database and Cloudinary. This action cannot be undone.`}
        </p>

        {error && (
          <p className="lud-permanent-delete-modal__error" role="alert">
            {error}
          </p>
        )}

        <div className="lud-permanent-delete-modal__confirmation">
          <p>
            {ar
              ? `الرجاء كتابة "${requiredConfirmation}" للتأكيد`
              : `Write "${requiredConfirmation}" to confirm`}
          </p>

          <Input
            value={confirmationText}
            onChange={(event) =>
              setConfirmationText(event.target.value)
            }
            placeholder={requiredConfirmation}
            autoComplete="off"
          />
        </div>

        <div className="lud-permanent-delete-modal__actions">
          <Button
            variant="danger"
            appearance="filled"
            disabled={!isConfirmationValid || deleting}
            loading={deleting}
            onClick={onConfirm}
          >
            {ar ? "حذف نهائي" : "Permanent delete"}
          </Button>

          <Button
            variant="primary"
            appearance="soft"
            disabled={deleting}
            onClick={onCancel}
          >
            {ar ? "إلغاء" : "Cancel"}
          </Button>
        </div>
      </div>
    </div>
  );
}
